export default {
  // so on dev we'll have
  VUE_APP_CLIENT_ID: window.$app.config.VUE_APP_CLIENT_ID,
  VUE_APP_CLIENT_SECRET: window.$app.config.VUE_APP_CLIENT_SECRET,
  VUE_APP_COOKIE_NAME: window.$app.config.VUE_APP_COOKIE_NAME,
  VUE_APP_TELEMETRY_ENABLED: window.$app.config.VUE_APP_TELEMETRY_ENABLED,
  VUE_APP_TELEMETRY_KEY: window.$app.config.VUE_APP_TELEMETRY_KEY,
  VUE_APP_ROOT_API: window.$app.config.VUE_APP_ROOT_API,
  VUE_APP_ERROR_LEVEL: window.$app.config.VUE_APP_ERROR_LEVEL,
  VUE_APP_BASE_URL: window.$app.config.VUE_APP_BASE_URL,
};
